import React, { useState } from 'react';
import { StyledLeafletCategory } from '../styles';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import { TLeafletItem } from 'src/types/types';
import { ICON_PATH } from 'src/utils/constants';

type TProps = {
  leafletData: TLeafletItem;
  setCategorySwiper: (swiperCore: SwiperCore) => void;
  contentSwiper?: SwiperCore;
  setSelectedTab: (i: number) => void;
  selectedTab: number;
  setGaEvent: (title: string) => void;
};
/**
 * @name 전단 카테고리
 */
function LeafletCategory(props: TProps): React.ReactElement {
  const [isMoreBtn, setIsMoreBtn] = useState<boolean>(false); // 더보기 버튼
  const [isSlide, setIsSlide] = useState<boolean>(false); // 스와이프 여부

  // 카테고리 변경
  const handleClickCategory = (category, i) => {
    if (i === props.selectedTab) return;
    props.setGaEvent(`전단 카테고리(${category.img_nm})`);
    const filterCategory = props.leafletData.leaflet_img_list.findIndex(
      (item, k) => k === i,
    );
    props.contentSwiper?.slideTo(filterCategory);
    props.setSelectedTab(filterCategory);
    setIsMoreBtn(false);
    window.scrollTo(0, 0);
  };

  // 카테고리 더보기
  const handleClickMoreBtn = () => {
    setIsMoreBtn(!isMoreBtn);
  };

  // 스와이퍼 정보 저장
  const handleSwiper = (e: SwiperCore) => {
    props.setCategorySwiper(e);
    // 슬라이드 유무 체크
    if (e.isLocked) {
      setIsSlide(false);
    } else {
      setIsSlide(true);
    }
  };

  return (
    <>
      {isMoreBtn && <div className="dim_leaflet"></div>}
      <StyledLeafletCategory>
        <Swiper
          className="cate_swiper"
          slidesPerView={'auto'}
          onSwiper={e => handleSwiper(e)}
        >
          {props.leafletData.leaflet_img_list.map((category, i) => {
            if (!category.img_nm) return;
            return (
              <SwiperSlide key={i}>
                <button
                  className="cate_swiper_list"
                  onClick={() => handleClickCategory(category, i)}
                >
                  <div className={`${props.selectedTab === i ? 'active' : ''}`}>
                    <p>{category.img_nm}</p>
                  </div>
                </button>
              </SwiperSlide>
            );
          })}
        </Swiper>
        {/* 더보기 열기 */}
        {isMoreBtn && (
          <div className="cate_more_box">
            <h2>전체메뉴</h2>
            <ul>
              {props.leafletData.leaflet_img_list.map((category, i) => {
                if (!category.img_nm) return;
                return (
                  <li
                    key={i}
                    className={`${props.selectedTab === i ? 'active' : ''}`}
                  >
                    <button onClick={() => handleClickCategory(category, i)}>
                      {category.img_nm}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {isSlide && (
          <div className={isMoreBtn ? 'more_btn active' : 'more_btn'}>
            <button title="더보기" onClick={handleClickMoreBtn}>
              <img src={`${ICON_PATH}/icon_dropdown.png`} alt="" />
            </button>
            {!isMoreBtn && <div className="more-gradient"></div>}
          </div>
        )}
      </StyledLeafletCategory>
    </>
  );
}

export default LeafletCategory;
